export const RSVP_BLOCK_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/rsvpBlockSchemaV1_0_0.json' as const;
export const RSVP_BLOCK_COMPONENT_TYPE = 'RsvpBlock' as const;
